import React, { useEffect, useMemo, useState } from 'react';
import { TitleBar } from '../../common';
import { BUTTON, POPUP_MSG, POPUP_TYPE, ROUTES, TITLES } from '../../../constants';
import { Button, PopUpBox } from '../../shared';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDebounce } from '../../../hooks';
import { popup } from '../../../utils';
import {
  getPreScannedPackages,
  vendorSubmitDispatch,
  addPackageToDispatch,
  printPackingListDispatch,
} from '../../../service';
import { useLoader } from '../../../context/LoaderContext';
import { shipmentDataCompiler } from '../../../utils/dataCompiler/dispatchDataCompiler';
import { FabricDispatchDetail } from './FabricDispatchDetail';
import { BlpTilesDispatch } from '../../common/BlpTilesDispatch';
import { ShipmentDetailsBox } from './CreateDispatch';
import ContainerThreadBoxEntry from '../../common/ContainerThreadBoxEntry';
import scan_success from '../../../assets/sounds/scan_success.mp3';
import scan_failed from '../../../assets/sounds/error.mp3';
import scan_duplicate from '../../../assets/sounds/duplicate.mp3';

export const DispatchDetail = () => {
  const { state } = useLocation();
  return (
    <>
      {state?.dyeing_shipment || state?.partner_id?.vendor_type === 'dyeing' ? (
        <FabricDispatchDetail />
      ) : (
        <DispatchDetailNonDyeing />
      )}
    </>
  );
};

const DispatchDetailNonDyeing = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { state } = useLocation();
  const [reload, setReload] = useState(false);
  const [scanData, setScanData] = useState('');
  const [scanning, setScanning] = useState(false);
  const [validate, setValidate] = useState(false);
  const [tilesToDisplay, setTilesToDisplay] = useState([]);
  const [preScannedPackages, setPreScannedPackages] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [search, setSearch] = useState(false);
  const [shipmentData, setShipmentData] = useState({
    warehouse_id: '',
    warehouse_name: '',
    invoice_no: '',
    physical_container_no: '',
    warehouse_options: [],
  });
  const [containerId, setContainerId] = useState(shipmentData.invoice_no || '');
  const [isCamScannerOpen, setIsCamScannerOpen] = useState(true);
  const isCameraScan = localStorage.getItem('isCameraScan');
  const isCameraScanBool = isCameraScan === 'true';
  const [costviewOpen, setCostviewOpen] = useState(false);
  const [isShipmentDataLoading, setIsShipmentDataLoading] = useState(false);
  const [isScanningLoading, setIsScanningLoading] = useState(false);
  const [isValidateLoading, setIsValidateLoading] = useState(false);
  const [sort1, setSort1] = useState('Box Type');
  const [sortingArray1, setSortingArray1] = useState(['Single Box', 'Mix Box']);
  let duplicateAudio = useMemo(() => new Audio(scan_success), []);
  let failedAudio = useMemo(() => new Audio(scan_failed), []);
  let successAudio = useMemo(() => new Audio(scan_duplicate), []);

  // useEffect(() => {
  //   if (Array.isArray(preScannedPackages)) {
  //     const filteredTiles = preScannedPackages.filter((tile) => {
  //       const isMixed = tile?.data?.is_mixed || tile?.data?.package_id?.is_mixed;

  //       if (sort1 === 'Mix Box') {
  //         return isMixed === true;
  //       }

  //       if (sort1 === 'Single Box') {
  //         return isMixed === false;
  //       }

  //       return true;
  //     });

  //     setTilesToDisplay(filteredTiles);
  //   }
  // }, [sort1]);

  const getAlreadyScannedPackages = useDebounce((searchData) => {
    setIsShipmentDataLoading(true);
    getPreScannedPackages({
      data: {
        picking_ids: state?.id,
        ...searchData,
        page_number: 1,
        sort:
          sort1 == 'Box Type'
            ? {}
            : { selection: { is_mixed: sort1 === 'Single Box' ? false : true } },
      },
    })
      .then((response) => {
        setIsShipmentDataLoading(false);
        if (!response) return;
        response?.data?.records?.length > 0
          ? (setPreScannedPackages(shipmentDataCompiler(response?.data?.records?.[0])),
            setShipmentData({
              warehouse_id: response?.data?.records?.[0]?.warehouse_id?.id,
              warehouse_name: response?.data?.records?.[0]?.warehouse_id?.name,
              invoice_no: response?.data?.records?.[0]?.invoice_no || '',
              physical_container_no: response?.data?.records?.[0]?.physical_container_no || '',
              warehouse_options: response?.data?.records?.[0]?.warehouse_ids,
            }))
          : setPreScannedPackages(response.message);
        setReload(false);
      })
      .catch(() => setIsShipmentDataLoading(false));
  }, 400);

  useEffect(() => {
    if (!state) navigate(ROUTES.DISPATCH_DETAILS);
    isCameraScanBool && !isCamScannerOpen ? setScanning(false) : '';
  });

  useEffect(() => {
    setIsShipmentDataLoading(true);
    getAlreadyScannedPackages();
  }, []);

  useEffect(() => {
    if (search && searchTerm) {
      const filtered = preScannedPackages.filter((pkg) => {
        return (
          pkg?.BLP?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
          pkg?.SKU?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
          pkg?.Batch?.toLowerCase()?.includes(searchTerm.toLowerCase())
        );
      });
      setSearch(false);
      if (filtered.length > 0) setPreScannedPackages(filtered);
      else {
        popup(POPUP_TYPE.ERR, 'No relevant packages found');
        setSearch(false);
        setSearchTerm('');
      }
      setLoading(false);
    } else if (!searchTerm && !Array.isArray(preScannedPackages)) {
      setSearch(false);
      setIsShipmentDataLoading(true);
      getAlreadyScannedPackages();
    }
  }, [search, searchTerm]);

  useEffect(() => {
    if (!searchTerm) {
      setIsShipmentDataLoading(true);
      getAlreadyScannedPackages();
    }
  }, [searchTerm]);

  useEffect(() => {
    if (reload) {
      setIsShipmentDataLoading(true);
      getAlreadyScannedPackages();
    }
  }, [reload]);

  useEffect(() => {
    if (Array.isArray(preScannedPackages)) {
      const filteredTiles = preScannedPackages
        .map((tile) => {
          const isMixedSKU = tile?.data?.is_mixed ?? tile?.data?.package_id?.is_mixed;
          const tileClass = isMixedSKU ? 'pink-shade' : 'blue-shade';
          return { ...tile, tileClass };
        })
        .filter((tile) => {
          const isMixed = tile?.data?.is_mixed ?? tile?.data?.package_id?.is_mixed;

          if (sort1 === 'Single Box') return isMixed === false;
          if (sort1 === 'Mix Box') return isMixed === true;

          return true;
        });

      setTilesToDisplay(filteredTiles);
    }
  }, [preScannedPackages, sort1]);

  useEffect(() => {
    if (scanData) {
      setIsScanningLoading(true);
      addPackageToDispatch({
        data: {
          dispatch_id: state?.id,
          package_name: scanData,
          type: 'add',
        },
      }).then((response) => {
        setIsScanningLoading(false);
        if (response) {
          if (response.data.length > 0) {
            setPreScannedPackages((prev) => [...prev, ...shipmentDataCompiler(response?.data[0])]);
            successAudio.play();
            popup(POPUP_TYPE.SUCCESS, response.message);
          } else if (response?.message.includes('Duplicate')) {
            duplicateAudio.play();
            popup(POPUP_TYPE.ERR, response.message);
          } else {
            failedAudio.play();
            popup(POPUP_TYPE.ERR, response.message);
          }
        } else {
          failedAudio.play();
        }
      });
      setScanData('');
    }
  }, [scanData]);

  return (
    <>
      <TitleBar
        title={[
          { text: TITLES.DISPATCH, route: ROUTES.DISPATCH },
          { text: state?.name, route: ROUTES.NULL },
        ]}
      />
      {costviewOpen && (
        <ContainerThreadBoxEntry setCostviewOpen={setCostviewOpen} state={state} isBill={false} />
      )}
      {isShipmentDataLoading && (
        <div className="text-center my-2">
          <span className="spinner-border spinner-border-sm text-primary" role="status" />
          <span className="ms-2">Loading...</span>
        </div>
      )}
      {!costviewOpen && !isShipmentDataLoading && (
        <ShipmentDetailsBox
          state={state}
          tilesToDisplay={tilesToDisplay}
          shipmentData={shipmentData}
          setScanning={setScanning}
          scanning={scanning}
          setIsCamScannerOpen={setIsCamScannerOpen}
          isCameraScanBool={isCameraScanBool}
          setScanData={setScanData}
          preScannedPackages={preScannedPackages}
          setValidate={setValidate}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          setSearch={setSearch}
          search={search}
          getAlreadyScannedPackages={getAlreadyScannedPackages}
          printPackageApi={printPackingListDispatch}
          costviewOpen={costviewOpen}
          setCostviewOpen={setCostviewOpen}
          isScanningLoading={isScanningLoading}
          isValidateLoading={isValidateLoading}
          setContainerId={setContainerId}
          sort1={sort1}
          setSort1={setSort1}
          sortingArray1={sortingArray1}
          setSortingArray1={setSortingArray1}
        />
      )}
      {!costviewOpen && (
        <div className="bg-white p-3 pt-0 mt-2 package-titles-info border-def-up border-def-down">
          <div className="row custom-row">
            {Array.isArray(preScannedPackages)
              ? tilesToDisplay.map((tile, index) => (
                  <BlpTilesDispatch
                    key={index}
                    tile={tile}
                    dispatch_id={state?.id}
                    dispatch_status={state?.dispatch_status}
                    showLoader={scanning}
                    setPreScannedPackages={setPreScannedPackages}
                  />
                ))
              : typeof preScannedPackages === 'string' && (
                  <div>
                    <h4 className="text-center px-1 py-5">{'Package not found'}</h4>
                  </div>
                )}
          </div>
        </div>
      )}
      {validate && (
        <PopUpBox openPopUpBox={validate}>
          <DispatchSubmitValidate
            setOpenPopUpBox={setValidate}
            id={state?.id}
            containerNo={containerId}
            setIsValidateLoading={setIsValidateLoading}
          />
        </PopUpBox>
      )}
    </>
  );
};

const DispatchSubmitValidate = ({ setOpenPopUpBox, id, containerNo, setIsValidateLoading }) => {
  // const navigate = useNavigate();
  const { setLoading } = useLoader();

  const closePopUp = () => {
    setOpenPopUpBox(false);
  };

  const handleSubmitDispatch = () => {
    setIsValidateLoading(true);
    setOpenPopUpBox(false);
    vendorSubmitDispatch({
      data: { dispatch_id: id },
    })
      .then((response) => {
        setIsValidateLoading(false);
        if (!response) return;
        popup('success', response.message);
        // navigate(ROUTES.DISPATCH);
        window.history.back();
      })
      .catch(() => {
        setIsValidateLoading(false);
        setLoading(false);
      });
  };

  const handleSaveAsDraft = () => {
    popup('success', 'Dispatch Saved as Draft');
    // navigate(ROUTES.DISPATCH);
    window.history.back();
  };

  return (
    <>
      <div className="d-flex m-1">
        <div className="w-25 modal-body py-0 d-flex justify-content-center align-items-center">
          <span className="d-flex justify-content-center align-items-center bg-info badge">!</span>
        </div>
        <div className="w-75 modal-body py-0">
          <h4 className="text-center text-special mb-3">
            <u>NOTE</u>
          </h4>
          <p className="text-center text-special placeholder-color">
            {POPUP_MSG.SUBMIT_DISPATCH_WARNING}
          </p>
        </div>
      </div>
      <hr />
      <div className="pb-3 mt-2 d-flex align-items-center justify-content-end mx-4 modal-btn custom-button">
        <div className="d-flex align-items-center justify-content-between">
          <Button
            clickHandler={handleSubmitDispatch}
            className={`border-0 m-1 ${containerNo === '' || containerNo === false || containerNo === 'N/A' ? 'disabled' : ''} blue-btn d-flex align-items-center justify-content-center py-2 px-3`}
            disabled={containerNo === '' || containerNo === false || containerNo === 'N/A'}>
            {BUTTON.SUBMIT}
          </Button>
          <Button
            clickHandler={handleSaveAsDraft}
            className="border-0 m-1 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
            {BUTTON.SAVE_AS_DRAFT}
          </Button>
          <Button
            clickHandler={closePopUp}
            className="border-0 m-1 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
            {BUTTON.CLOSE}
          </Button>
        </div>
      </div>
    </>
  );
};
